import { assets, footer, identity } from "@/config";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-line bg-noir">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 py-16 text-center sm:px-8">
        <img src={assets.logo} alt={identity.brand} className="h-14 w-auto sm:h-16" loading="lazy" />
        <p className="text-sm text-gray2">{footer.built}</p>
        <p className="text-sm text-gray2">{footer.joke}</p>
        <p className="font-serif text-base italic text-gold/80">{footer.signoff}</p>
      </div>
    </footer>
  );
}
